import { api } from '@shared/api/api';
import { Nullable } from '@shared/utils/types/Nullable';

type ParkingRequestData = App.Domain.Parking.Data.ParkingRequestData;

export type UpdateParkingRequestData = Nullable<Pick<ParkingRequestData, 'parkingId' | 'crewMemberId' | 'days'>> & {
  claimFreedUpDays: boolean;
};

export const updateParkingRequest = (
  parkingRequestId: number,
  registrationId: number,
  data: UpdateParkingRequestData
) => api.put<ParkingRequestData>(`/registrations/${registrationId}/parking-requests/${parkingRequestId}`, data);
